/* src/app/commons/components/ground-triangle/ground-triangle.component.scss */
.triangle {
  position: relative;
}
.point {
  position: absolute;
  transition: left 0.5s ease-in, top 0.5s ease-in;
  display: inline-block;
  border: 6px solid black;
  border-radius: 6px;
}
/*# sourceMappingURL=ground-triangle.component.css.map */
